import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleUp as fasAngleDoubleUp,
  faArrowLeft as fasArrowLeft,
  faCamera as fasCamera,
  faCheckCircle as fasCheckCircle,
  faCommentAltCheck as fasCommentAltCheck,
  faCrown as fasCrown,
  faEnvelope as fasEnvelope,
  faExclamationTriangle as fasExclamationTriangle,
  faEye as fasEye,
  faEyeSlash as fasEyeSlash,
  faFileExcel as fasFileExcel,
  faFileUpload as fasFileUpload,
  faInfoCircle as fasInfoCircle,
  faKey as fasKey,
  faLifeRing as fasLifeRing,
  faMapMarkerAlt as fasMapMarkerAlt,
  faPen as fasPen,
  faPortrait as fasPortrait,
  faPowerOff as fasPowerOff,
  faQrcode as fasQrcode,
  faTrash as fasTrash,
  faUserFriends as fasUserFriends,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faAngleDoubleUp as farAngleDoubleUp,
  faAngleDown as farAngleDown,
  faArrowToBottom as farArrowToBottom,
  faCheck as farCheck,
  faChevronRight as farChevronRight,
  faClock as farClock,
  faEllipsisV as farEllipsisV,
  faHourglassHalf as farHourglassHalf,
  faIdBadge as farIdBadge,
  faPlus as farPlus,
  faQrcode as farQrcode,
  faSearch as farSearch,
  faTimes as farTimes,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faBarcode as falBarcode,
  faCircle as falCircle,
  faQuoteLeft as falQuoteLeft,
  faQrcode as falQrcode,
  faSpinnerThird as falSpinnerThird,
  faTimes as falTimes,
  faUserCircle as falUserCircle,
} from '@fortawesome/pro-light-svg-icons';
import {
  faAngleDoubleUp as fadAngleDoubleUp,
  faCalendarDay as fadCalendarDay,
  faClipboardList as fadClipboardList,
  faClipboardListCheck as fadClipboardListCheck,
  faCogs as fadCogs,
  faCrown as fadCrown,
  faExclamationTriangle as fadExclamationTriangle,
  faFileSpreadsheet as fadFileSpreadsheet,
  faUserCircle as fadUserCircle,
  faUserCog as fadUserCog,
  faUserFriends as fadUserFriends,
  faUsers as fadUsers,
} from '@fortawesome/pro-duotone-svg-icons';
import {
  faAndroid,
  faApple,
  faFacebookF,
  faGoogle,
} from '@fortawesome/free-brands-svg-icons';

// Light style
library.add(
  falBarcode,
  falCircle,
  falQuoteLeft,
  falSpinnerThird,
  falQrcode,
  falTimes,
  falUserCircle,
);

// Solid style
library.add(
  fasAngleDoubleUp,
  fasArrowLeft,
  fasCamera,
  fasCheckCircle,
  fasCommentAltCheck,
  fasCrown,
  fasEnvelope,
  fasExclamationTriangle,
  fasEye,
  fasEyeSlash,
  fasFileExcel,
  fasFileUpload,
  fasInfoCircle,
  fasKey,
  fasLifeRing,
  fasMapMarkerAlt,
  fasPen,
  fasPortrait,
  fasPowerOff,
  fasQrcode,
  fasTrash,
  fasUserFriends,
);

// Regular style
library.add(
  farAngleDoubleUp,
  farAngleDown,
  farArrowToBottom,
  farCheck,
  farChevronRight,
  farClock,
  farEllipsisV,
  farHourglassHalf,
  farIdBadge,
  farQrcode,
  farPlus,
  farSearch,
  farTimes,
);

// Duotone style
library.add(
  fadAngleDoubleUp,
  fadCalendarDay,
  fadClipboardList,
  fadClipboardListCheck,
  fadCogs,
  fadCrown,
  fadExclamationTriangle,
  fadFileSpreadsheet,
  fadUserCircle,
  fadUserCog,
  fadUserFriends,
  fadUsers,
);

// Brand style
library.add(
  faAndroid,
  faApple,
  faFacebookF,
  faGoogle,
);
